import { render, staticRenderFns } from "./AboutUsMobile.vue?vue&type=template&id=87b8c6ec&scoped=true"
import script from "./AboutUsMobile.vue?vue&type=script&lang=js"
export * from "./AboutUsMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b8c6ec",
  null
  
)

export default component.exports